import { render, staticRenderFns } from "./form_transfor.vue?vue&type=template&id=70945755&scoped=true"
import script from "./form_transfor.vue?vue&type=script&lang=js"
export * from "./form_transfor.vue?vue&type=script&lang=js"
import style0 from "./form_transfor.vue?vue&type=style&index=0&id=70945755&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70945755",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70945755')) {
      api.createRecord('70945755', component.options)
    } else {
      api.reload('70945755', component.options)
    }
    module.hot.accept("./form_transfor.vue?vue&type=template&id=70945755&scoped=true", function () {
      api.rerender('70945755', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/visit_manage/line_group_management/form/components/form_transfor.vue"
export default component.exports